<img src="./assets/media/images/general/fill-form-first.png">
<div>{{'GENERAL.ENTER_THE_INFORMATION_FIRST' | translate}}</div>